import { BerthReservationVersion as ServerBerthReservationVersion } from 'server/models/BerthReservationVersion';
import { BerthReservationVersionExtraDataData } from './BerthReservationVersionExtraData';
import { BerthReservationStatus } from 'server/enums/BerthReservation';
import { parseIfNonNull } from './ExtraDataUtils';

export { BerthReservationVersionData, BerthReservationVersionOptions } from 'server/models/BerthReservationVersion';

export class BerthReservationVersion extends ServerBerthReservationVersion {
    ExtraData() {
        return parseIfNonNull<BerthReservationVersionExtraDataData>(this.ExtraDataJSON());
    }

    Status() {
        // Status field is derived from other fields
        return this.CancelledDate() !== null ? BerthReservationStatus.Cancelled :
               this.ConflictCount() > 0      ? BerthReservationStatus.Conflicted :
               this.ApprovedDate() !== null  ? BerthReservationStatus.Booked :
               BerthReservationStatus.Requested;
    }
}



// WEBPACK FOOTER //
// ./data/models/BerthReservationVersion.ts